import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f495ae28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hd-template__nav"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_template_area = _resolveComponent("template-area")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade-in-right" }, {
      default: _withCtx(() => [
        (_ctx.ready)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["hd-template hd-container", { 'is-ready': _ctx.ready }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateRows, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${_ctx.endpointId}-${item}`,
                  class: _normalizeClass(["hd-row", `hd-row__${_ctx.endpointId}`])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateGrammar[item], (col, index) => {
                    return (_openBlock(), _createBlock(_component_template_area, {
                      key: `${_ctx.endpointId}-${index}`,
                      datum: col,
                      class: "hd-col",
                      "carousel-index": _ctx.slideIndexActive
                    }, null, 8, ["datum", "carousel-index"]))
                  }), 128))
                ], 2))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isCarousel && _ctx.ready)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselSlides, (slide, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["hd-template__nav-item crux-click", { 'is-active': _ctx.slideIndexActive === index }]),
                  "data-crux": "endpoint-carousel-dot",
                  onClick: ($event: any) => (_ctx.setCarouselTemplateActive(index))
                }, null, 10, _hoisted_2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}